export enum NotificationType {
  Info = 0,
  Alert = 1,
  Error = 2,
}

export interface INotification {
  _id: string;
  title: string;
  message: string;
  type: number;
  products: Array<string>;
  sports: Array<string>;
  created: string;
}
